import { generateTagLabelsCommand } from "./generateTagLabelsCommand";

export default generateTagLabelsCommand;
